<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div v-if="isRender" class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">User</h4>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">ID</label>
              <label class="col-form-label col-lg-8">{{ user.id }}</label>
            </div>
            <!-- <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">Version 2 Id</label>
              <div class="col-lg-8">
                <input
                  id="psgv2_id"
                  name="psgv2_id"
                  v-model="user.reference_id.psgv2_id"
                  type="number"
                  class="form-control"
                  placeholder="Version 2 Id"
                  maxlength="30"
                /> -->
            <!-- v-on:keyup="onValidateV2Id($event)" -->
            <!-- :class="{
                    'is-invalid': invalid.psgv2_id,
                    'is-valid':
                      !invalid.psgv2_id && user.reference_id.psgv2_id !== '',
                  }" -->
            <!-- <div v-if="invalid.psgv2_id" class="invalid-feedback">
                  <span v-if="textError.psgv2_id">{{
                    textError.psgv2_id
                  }}</span>
                </div> -->
            <!-- </div>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">CRC Id</label>
              <div class="col-lg-8">
                <input
                  id="crc_id"
                  name="crc_id"
                  v-model="user.reference_id.crc_id"
                  type="text"
                  class="form-control"
                  placeholder="CRC Id"
                  maxlength="30"
                /> -->
            <!-- :class="{
                    'is-invalid': invalid.crc_id,
                    'is-valid':
                      !invalid.crc_id &&
                      user.reference_id.crc_id !== '',
                  }"
                  v-on:keyup="onValidateCRCId($event)"
                <div v-if="invalid.crc_id" class="invalid-feedback">
                  <span v-if="textError.crc_id">{{
                    textError.crc_id
                  }}</span>
                </div> -->
            <!-- </div>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">OFM Id</label>
              <div class="col-lg-8">
                <input
                  id="ofm_id"
                  name="ofm_id"
                  v-model="user.reference_id.ofm_id"
                  type="text"
                  class="form-control"
                  placeholder="OFM Id"
                  maxlength="30"
                /> -->
            <!-- :class="{
                    'is-invalid': invalid.ofm_id,
                    'is-valid':
                      !invalid.ofm_id &&
                      user.reference_id.ofm_id !== '',
                  }"
                  v-on:keyup="onValidateOFMId($event)"
                <div v-if="invalid.ofm_id" class="invalid-feedback">
                  <span v-if="textError.ofm_id">{{
                    textError.ofm_id
                  }}</span>
                </div> -->
            <!-- </div>
            </div> -->
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">First Name</label>
              <div class="col-lg-8">
                <input
                  id="info_first_name_th"
                  name="info_first_name_th"
                  v-model="user.info.first_name.th"
                  type="text"
                  class="form-control"
                  placeholder="First Name"
                  maxlength="30"
                  :class="{
                    'is-invalid': invalid.info_first_name,
                    'is-valid':
                      !invalid.info_first_name &&
                      user.info.first_name.th !== '',
                  }"
                  v-on:keyup="onValidateInfoFirstNameTh($event)"
                />
                <div v-if="invalid.info_first_name" class="invalid-feedback">
                  <span v-if="textError.info_first_name">{{
                    textError.info_first_name
                  }}</span>
                </div>
              </div>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">Last Name</label>
              <div class="col-lg-8">
                <input
                  id="info_last_name"
                  name="info_last_name"
                  v-model="user.info.last_name.th"
                  type="text"
                  class="form-control"
                  placeholder="Last Name"
                  maxlength="30"
                  :class="{
                    'is-invalid': invalid.info_last_name,
                    'is-valid':
                      !invalid.info_last_name && user.info.last_name.th !== '',
                  }"
                  v-on:keyup="onValidateInfoLastNameTh($event)"
                />
                <div v-if="invalid.info_last_name" class="invalid-feedback">
                  <span v-if="textError.info_last_name">{{
                    textError.info_last_name
                  }}</span>
                </div>
              </div>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">First Name (En)</label>
              <div class="col-lg-8">
                <input
                  id="info_first_name_en"
                  name="info_first_name_en"
                  v-model="user.info.first_name.en"
                  type="text"
                  class="form-control"
                  placeholder="First Name (En)"
                  maxlength="30"
                  :class="{
                    'is-invalid': invalid.info_first_name_en,
                    'is-valid':
                      !invalid.info_first_name_en &&
                      user.info.first_name.en !== '',
                  }"
                  v-on:keyup="onValidateInfoFirstNameEn($event)"
                />
                <div v-if="invalid.info_first_name_en" class="invalid-feedback">
                  <span v-if="textError.info_first_name_en">{{
                    textError.info_first_name_en
                  }}</span>
                </div>
              </div>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">Last Name (En)</label>
              <div class="col-lg-8">
                <input
                  id="info_last_name_en"
                  name="info_last_name_en"
                  v-model="user.info.last_name.en"
                  type="text"
                  class="form-control"
                  placeholder="Last Name (En)"
                  maxlength="30"
                  :class="{
                    'is-invalid': invalid.info_last_name_en,
                    'is-valid':
                      !invalid.info_last_name_en &&
                      user.info.last_name.en !== '',
                  }"
                  v-on:keyup="onValidateInfoLastNameEn($event)"
                />
                <div v-if="invalid.info_last_name_en" class="invalid-feedback">
                  <span v-if="textError.info_last_name_en">{{
                    textError.info_last_name_en
                  }}</span>
                </div>
              </div>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">Credentials</label>
              <div class="col-lg-8">
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive">
                      <b-table
                        class="table table-centered table-nowrap"
                        ref="grouptable"
                        :empty-text="'Not found any result'"
                        :show-empty="user.user_credentials.length == 0"
                        :bordered="true"
                        :items="user.user_credentials"
                        align="center"
                        v-bind:fields="fields"
                      >
                        <template v-slot:cell(index)="data">
                          <div class="text-right">
                            {{ firstRowOnPage + data.index }}
                          </div>
                        </template>
                        <template v-slot:cell(status)="data">
                          <span
                            class="label"
                            :class="'label-x' + data.value.toLowerCase()"
                            v-html="data.value"
                          ></span>
                        </template>
                        <template v-slot:cell(is_verify)="data">
                          {{ data.value ? "Yes" : "No" }}
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">Email</label>
              <div class="col-lg-8">
                <input
                  id="info_last_name_en"
                  name="info_last_name_en"
                  v-model="user.info.email"
                  type="email"
                  class="form-control"
                  placeholder="Email"
                  maxlength="30"
                  :class="{
                    'is-invalid': invalid.info_email,
                    'is-valid':
                      !invalid.info_email &&
                      user.info.email !== '',
                  }"
                  v-on:keyup="onValidateInfoEmail($event)"
                />
                <div v-if="invalid.info_email" class="invalid-feedback">
                  <span v-if="textError.info_email">{{
                    textError.info_email
                  }}</span>
                </div>
              </div>
            </div>
            <div class="row">
              <label class="col-form-label col-lg-2">สถานะ</label>
              <div class="col-form-label col-lg-8">
                <div class="row col-lg-12">
                  <b-form-radio
                    v-model="user.status"
                    name="status"
                    class="custom-control custom-radio custom-radio-info mb-3"
                    value="Offline"
                    style="margin-right: 10px"
                    >Offline</b-form-radio
                  >
                  <b-form-radio
                    v-model="user.status"
                    name="status"
                    class="custom-control custom-radio custom-radio-info mb-3"
                    value="Online"
                    style="margin-right: 10px"
                    >Online</b-form-radio
                  >
                </div>
              </div>
            </div> -->
            <div class="form-group mb-4 text-center">
              <div class="button-items">
                <button type="button" class="btn btn-primary" @click="onSave()">
                  Save
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  @click="onCancel()"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Vue from "vue";
import DatePicker from "vue2-datepicker";
import Swal from "sweetalert2";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import userService from "@/helpers/service/user-provider";
import { eventBus } from "@/main.js";
import {
  TypeEnum,
  ChannelAllowEnum,
  ChannelAllowTypeEnum,
} from "@/enum/user.enum.js";

/**
 * Projects-create component
 */
export default {
  page: {
    title: "Create New User",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      id: "",
      title: "Create New",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "User",
          href: "/users",
        },
        {
          text: "Create New",
          active: true,
        },
      ],
      user: {},
      invalid: {
        // psgv2_id: false,
        // crc_id: false,
        // ofm_id: false,
        // status: false,
        info_first_name: false,
        info_last_name: false,
        info_first_name_en: false,
        info_last_name_en: false,
        // info_email: false,
        // info_phones: false
      },
      textError: {
        // psgv2_id: "",
        // crc_id: "",
        // ofm_id: "",
        // status: "",
        info_first_name: "",
        info_last_name: "",
        info_first_name_en: "",
        info_last_name_en: "",
        // info_email: "",
        // info_phones: ""
      },
      fields: [
        {
          key: "index",
          label: "index",
          thStyle: "width:80px",
          sortable: true,
        },
        {
          key: "channel",
          label: "Channel",
          sortable: true,
        },
        {
          key: "channel_type",
          label: "Channel Type",
          sortable: true,
        },
        {
          key: "is_verify",
          label: "Verify",
          sortable: true,
        },
        {
          key: "source_user",
          label: "User Name",
          sortable: true,
        },
        {
          key: "status",
          label: "status",
          sortable: true,
          tdClass: "text-center",
        },
      ],
      isRender: false,
      firstRowOnPage : 1,
    };
  },
  created: function () {
    this.id = this.$route.params.id;
  },
  mounted: function () {
    this.getDetail();
  },
  methods: {
    async getDetail() {
    //  console.log(this.id);
      let result = await userService.getUserAsync(this.id);
      if (result.status === 200) {
        this.user = result.data;
        await this.onValidateAll();
        this.isRender = this;
      //  console.log("this.user", this.user);
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },
    async onSave() {
      let valid = await this.onValidateAll();
     // console.log("valid", valid);
      if (valid) {
        return;
      } else {
        // this.user.status = this.user.status.toUpperCase()
        // if (this.action === "new") {
        //   let result = await userService.createUserAsync(
        //     this.user
        //   );
        //   if (result.status === 201) {
        //     // eventBus.$emit("info-modal", "เพิ่มข้อมูลสำเร็จ");
        //     Vue.swal({
        //       position: "top-end",
        //       icon: "success",
        //       title: "Your work has been saved",
        //       showConfirmButton: false,
        //       timer: 1500,
        //     });
        //     this.$router.push({
        //       path: "/users",
        //     });
        //     // this.clearForm();
        //   } else {
        //     eventBus.$emit("error-modal", result.response.data.message);
        //   }
        // } else {
        let result = await userService.updateUserAsync(this.id, {
          info: {
            first_name: {
              th: this.user.info.first_name.th,
              en: this.user.info.first_name.en,
            },
            last_name: {
              th: this.user.info.last_name.th,
              en: this.user.info.last_name.en,
            },
          },
        });
        if (result.status == 204) {
          // eventBus.$emit("info-modal", "แก้ไขข้อมูลสำเร็จ");
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500,
          });
          this.$router.push({
            path: "/users",
          });
        } else {
          eventBus.$emit("error-modal", result.response.data.message);
        }
        // }
      }
    },
    onCancel() {
      this.$router.push({
        path: "/users",
      });
    },
    async onValidateAll() {
      // await this.onValidateV2Id()
      // await this.onValidateCRCId()
      // await this.onValidateOFMId()
      // await this.onValidateInfoEmail()
      await this.onValidateInfoFirstNameTh();
      await this.onValidateInfoLastNameTh();
      await this.onValidateInfoFirstNameEn();
      await this.onValidateInfoLastNameEn();
      return (
        // this.invalid.psgv2_id ||
        // this.invalid.crc_id ||
        // this.invalid.ofm_id ||
        // this.invalid.status ||
        this.invalid.info_first_name ||
        this.invalid.info_last_name ||
        this.invalid.info_first_name_en ||
        this.invalid.info_last_name_en
        // this.invalid.info_email
      );
    },
    // async onValidateV2Id() {
    //   if (
    //     this.user.reference_id.psgv2_id === "" ||
    //     this.user.reference_id.psgv2_id === null ||
    //     this.user.reference_id.psgv2_id === undefined
    //   ) {
    //     this.invalid.psgv2_id = true;
    //     this.textError.psgv2_id = "กรุณากรอก Version 2 id";
    //   } else {
    //     let params = new URLSearchParams();
    //     params.append("psgv2_id", this.user.reference_id.psgv2_id);
    //     if (this.action !== "new") {
    //       params.append("id", this.id);
    //     }
    //     let result = await userService.headUserAsync(params);
    //     if (result.status === 200) {
    //       this.invalid.psgv2_id = true;
    //       this.textError.psgv2_id = "Version 2 id ซ้ำกับในระบบ";
    //     } else if (result.response.status === 404) {
    //       this.invalid.psgv2_id = false;
    //       this.textError.psgv2_id = "";
    //     } else {
    //       eventBus.$emit("error-modal", result.response.data.message);
    //     }
    //   }
    // },
    // async onValidateCRCId() {
    //   if (
    //     this.user.reference_id.crc_id === "" ||
    //     this.user.reference_id.crc_id === null ||
    //     this.user.reference_id.crc_id === undefined
    //   ) {
    //     this.invalid.crc_id = true;
    //     this.textError.crc_id = "กรุณากรอก CRC Id";
    //   } else {
    //     let params = new URLSearchParams();
    //     params.append("crc_id", this.user.reference_id.crc_id);
    //     if (this.action !== "new") {
    //       params.append("id", this.id);
    //     }
    //     let result = await userService.headUserAsync(params);
    //     if (result.status === 200) {
    //       this.invalid.crc_id = true;
    //       this.textError.crc_id = "ชื่อ CRC Id ซ้ำกับในระบบ";
    //     } else if (result.response.status === 404) {
    //       this.invalid.crc_id = false;
    //       this.textError.crc_id = "";
    //     } else {
    //       eventBus.$emit("error-modal", result.response.data.message);
    //     }
    //   }
    // },
    // async onValidateOFMId() {
    //   if (
    //     this.user.reference_id.ofm_id === "" ||
    //     this.user.reference_id.ofm_id === null ||
    //     this.user.reference_id.ofm_id === undefined
    //   ) {
    //     this.invalid.ofm_id = true;
    //     this.textError.ofm_id = "กรุณากรอก OFM Id";
    //   } else {
    //     let params = new URLSearchParams();
    //     params.append("ofm_id", this.user.reference_id.ofm_id);
    //     if (this.action !== "new") {
    //       params.append("id", this.id);
    //     }
    //     let result = await userService.headUserAsync(params);
    //     if (result.status === 200) {
    //       this.invalid.ofm_id = true;
    //       this.textError.ofm_id = "ชื่อ User Code ซ้ำกับในระบบ";
    //     } else if (result.response.status === 404) {
    //       this.invalid.ofm_id = false;
    //       this.textError.ofm_id = "";
    //     } else {
    //       eventBus.$emit("error-modal", result.response.data.message);
    //     }
    //   }
    // },
    // async onValidateInfoEmail() {
    //   if (
    //     this.user.info.email === "" ||
    //     this.user.info.email === null ||
    //     this.user.info.email === undefined
    //   ) {
    //     this.invalid.info_email = true;
    //     this.textError.info_email = "กรุณากรอก Email";
    //   }
    //   else if (!this.validEmail(this.user.info.email)) {
    //     this.invalid.info_email = true;
    //     this.textError.info_email = "Email ไม่ถูกต้อง";
    //   }
    //   else {
    //     let params = new URLSearchParams();
    //     params.append("email", this.user.info.email);
    //     if (this.action !== "new") {
    //       params.append("id", this.id);
    //     }
    //     let result = await userService.headUserAsync(params);
    //     console.log(result)
    //     if (result.status === 200) {
    //       this.invalid.info_email = true;
    //       this.textError.info_email = "ชื่อ Email ซ้ำกับในระบบ";
    //     } else if (result.response.status === 404) {
    //       this.invalid.info_email = false;
    //       this.textError.info_email = "";
    //     } else {
    //       eventBus.$emit("error-modal", result.response.data.message);
    //     }
    //   }
    // },
    async onValidateInfoFirstNameTh() {
      if (
        this.user.info.first_name.th === undefined ||
        this.user.info.first_name.th === null ||
        this.user.info.first_name.th === ""
      ) {
        this.invalid.info_first_name = true;
        this.textError.info_first_name = "กรุณากรอก First Name";
      } else {
        this.invalid.info_first_name = false;
        this.textError.info_first_name = "";
      }
    },
    async onValidateInfoLastNameTh() {
      if (
        this.user.info.last_name.th === undefined ||
        this.user.info.last_name.th === null ||
        this.user.info.last_name.th === ""
      ) {
        this.invalid.info_last_name = true;
        this.textError.info_last_name = "กรุณากรอก Last Name";
      } else {
        this.invalid.info_last_name = false;
        this.textError.info_last_name = "";
      }
    },
    async onValidateInfoFirstNameEn() {
      if (
        this.user.info.first_name.en === undefined ||
        this.user.info.first_name.en === null ||
        this.user.info.first_name.en === ""
      ) {
        this.invalid.info_first_name_en = true;
        this.textError.info_first_name_en = "กรุณากรอก First Name (En)";
      } else {
        this.invalid.info_first_name_en = false;
        this.textError.info_first_name_en = "";
      }
    },
    async onValidateInfoLastNameEn() {
      if (
        this.user.info.last_name.en === undefined ||
        this.user.info.last_name.en === null ||
        this.user.info.last_name.en === ""
      ) {
        this.invalid.info_last_name_en = true;
        this.textError.info_last_name_en = "กรุณากรอก Last Name (En)";
      } else {
        this.invalid.info_last_name_en = false;
        this.textError.info_last_name_en = "";
      }
    },
    // async onValidateInfoPhone() {
    //   if (
    //     this.user.info.phones.length > 0
    //   ) {
    //     this.invalid.info_phones = true;
    //     this.textError.info_phones = "กรุณากรอก Phones";
    //   } else {
    //     this.invalid.info_phones = false;
    //     this.textError.info_phones = "";
    //   }
    // },
    clearForm() {
      this.user = {};

      // this.invalid.psgv2_id = false
      // this.invalid.crc_id = false
      // this.invalid.ofm_id = false
      // this.invalid.status = false
      this.invalid.info_first_name = false;
      this.invalid.info_last_name = false;
      this.invalid.info_first_name_en = false;
      this.invalid.info_last_name_en = false;
      // this.invalid.info_email = false
      // this.invalid.info_phones = false

      // this.textError.psgv2_id = ""
      // this.textError.crc_id = ""
      // this.textError.ofm_id = ""
      // this.textError.status = ""
      this.textError.info_first_name = "";
      this.textError.info_last_name = "";
      this.textError.info_first_name_en = "";
      this.textError.info_last_name_en = "";
      // this.textError.info_email = ""
      // this.textError.info_phones = ""
    },
    validEmail: function (email) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  },
};
</script>

<style scoped>
.switches-channel {
  margin-top: 13px;
}
</style>
